export default "__VITE_ASSET__VxEMLj6N__";